import type { URLSearchParamsQuery } from '@/types';
import { queryEndpoint } from '@/utils/queryEndpoint';

export const getData = (endpoint: string, query?: URLSearchParamsQuery) => () =>
  queryEndpoint(endpoint, { method: 'GET', query });
